// Add a language: one entry here plus one src/i18n/locales/<code>/ folder (see docs/i18n.md).
export const SUPPORTED_LANGUAGES = [
  { code: 'vi', nativeName: 'Tiếng Việt', short: 'VI' },
  { code: 'en', nativeName: 'English', short: 'EN' },
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const DEFAULT_LANGUAGE: Language = 'vi';

export function isLanguage(value: unknown): value is Language {
  return SUPPORTED_LANGUAGES.some((language) => language.code === value);
}
